module.exports = __webpack_public_path__ + "img/stanford-logo.8385bf52.png";